const enUS = {
  // ChatWidget
  "chat.welcome.title": "OceanMCP",
  "chat.welcome.description": "Your browser-in-the-loop AI assistant. I can read data, execute actions, and automate workflows within this application.",
  "chat.welcome.suggestion1": "What's on this page?",
  "chat.welcome.suggestion2": "Show me the page info",
  "chat.welcome.suggestion3": "What can you do?",
  "chat.input.placeholder": "Send a message...",
  "chat.upload.title": "Upload file",
  "chat.upload.uploading": "Uploading...",
  "chat.upload.remove": "Remove",
  "chat.dragdrop.title": "Drop files here",
  "chat.dragdrop.description": "Release to upload",
  "chat.error.label": "Error:",
  "chat.stop.title": "Stop generating",
  "chat.command.new": "Create and switch to a new session",
  "chat.command.sessions": "Browse and switch session history",
  "chat.session.open": "Session history",
  "chat.session.title": "Chat Sessions",
  "chat.session.description": "Switch, delete, or create a new session",
  "chat.session.new": "New session",
  "chat.session.close": "Close",
  "chat.session.empty": "No sessions yet",
  "chat.session.untitled": "Untitled session",
  "chat.session.updatedAt": "Updated: {time}",
  "chat.session.delete": "Delete",
  "chat.session.deleteConfirm": "Delete this session?",

  // MessageRenderer
  "tool.status.complete": "Complete",
  "tool.status.error": "Error",
  "tool.status.running": "Running",
  "tool.status.denied": "Denied",
  "tool.inline.running": "Calling {name}...",
  "tool.inline.complete": "Called {name}",
  "tool.inline.error": "Failed to call {name}",
  "tool.inline.denied": "Call {name} denied",
  "tool.label.result": "Result",
  "tool.label.parameters": "Parameters",
  "tool.renderError": "Render error:",
  "copy.title": "Copy",

  // MessageReasoning
  "reasoning.loading": "Thinking...",
  "reasoning.title": "Thought Content",
  "thinking.running": "Thinking...",
  "thinking.done": "Thought process complete",
  "thinking.stopped": "Thinking stopped",
  "thinking.error": "Completed with errors",
  "thinking.callingTool": "Calling Tool {name}...",
  "thinking.loadingSkill": "Loading Skill {name}...",

  // FlowNodeCard
  "flow.title": "Execution Plan",
  "flow.stepCount": "{count} step(s)",
  "flow.approve": "Allow",
  "flow.deny": "Deny",
  "flow.showMore": "Show {count} more rows",
  "flow.collapse": "Collapse",
  "flow.itemCount": "{count} item(s)",
  "flow.rawData": "Raw Data",
  "flow.showError": "Show more",
  "flow.hideError": "Show less",

  // ApprovalButtons
  "approval.status": "Pending",
  "approval.parameters": "Parameters",
  "approval.allow": "Allow",
  "approval.deny": "Deny",

  // AskUserCard
  "askUser.title": "User Input",
  "askUser.status.complete": "Complete",
  "askUser.status.error": "Error",
  "askUser.status.pending": "Pending",
  "askUser.status.denied": "Denied",
  "askUser.submitted": "Submitted",
  "askUser.value": "Value:",
  "askUser.failed": "Input failed.",
  "askUser.prompt": "Please provide the requested information:",
  "askUser.confirm": "Submit",
  "askUser.deny": "Cancel",
  "askUser.deniedMessage": "Input was cancelled.",
  "askUser.required": "Required",
  "askUser.selectPlaceholder": "Select an option",
  "askUser.inputPlaceholder": "Enter value",

  // SubagentCard
  "subagent.title": "Subtask",
  "subagent.status.running": "Running...",
  "subagent.status.complete": "Complete",
  "subagent.status.error": "Failed",
  "subagent.status.timeout": "Timed out",
  "subagent.systemPrompt": "System Prompt",
  "subagent.modelOutput": "Model Output (returned to main agent)",
};

export default enUS;
